import { render, staticRenderFns } from "./DraftOfferView.vue?vue&type=template&id=6c332d66&"
import script from "./DraftOfferView.vue?vue&type=script&lang=js&"
export * from "./DraftOfferView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports